import { createActionGroup, props } from '@ngrx/store';
import { Conversation, Message, MetadataInterface, Trace } from '../models/copilot.models';

export const CopilotActions = createActionGroup({
  source: 'Copilot',
  events: {
    'Select Client': props<{ clientId: string }>(),
    'Select Conversation': props<{
      clientId: string;
      conversationId: string;
      view?: 'active' | 'archived';
    }>(),
    'Load Conversations': props<{ clientId: string }>(),
    'Load Conversations Success': props<{ clientId: string; conversations: Conversation[] }>(),
    'Load Conversations Failure': props<{ clientId: string; error: any }>(),

    'Load Messages': props<{ clientId: string; conversationId: string, forceRefresh?: boolean }>(),
    'Load Messages Success': props<{ clientId: string; conversationId: string; messages: Message[], fromCache?: boolean }>(),
    'Load Messages Failure': props<{ clientId: string; conversationId: string; error: any }>(),

    'Send Message': props<{ clientId: string; conversationId: string; content: string; fileName?: string }>(),
    'Message Received': props<{
      clientId: string;
      conversationId: string;
      message: Message,
      owner_id?: string
    }>(),
    'Message Updated': props<{
      clientId: string;
      conversationId: string;
      content: string;
      messageId?: string;
      traces?: Trace[];
      metadata?: MetadataInterface
    }>(),

    'Start Streaming': props<{ clientId: string; conversationId: string }>(),
    'Stop Streaming': props<{ clientId: string; conversationId: string }>(),

    'Archive Conversation': props<{ clientId: string; conversationId: string }>(),
    'Close Conversation': props<{ clientId: string; conversationId: string }>(),
    'Trigger Client Highlight': props<{ clientId: string }>(),
    'Clear Client Highlight': props<{ clientId: string }>(),
    'Clear Client': props<{ clientId: string }>(),
    'Update Input Text': props<{ clientId: string; conversationId: string; text: string }>(),
    'Clear Input Text': props<{ clientId: string; conversationId: string }>(),
    'Trigger Conversation Highlight': props<{ clientId: string; conversationId: string }>(),
    'Clear Conversation Highlight': props<{ clientId: string; conversationId: string }>(),

    'Update Chat Search Query': props<{
      clientId: string;
      conversationId: string;
      query: string;
    }>(),
    'Set Chat Search Active Match Index': props<{
      clientId: string;
      conversationId: string;
      activeMatchIndex: number;
    }>(),
    'Clear Chat Search': props<{ clientId: string; conversationId: string }>(),
  }
});
